import { render, staticRenderFns } from "./FacilityOwnerCompanies.vue?vue&type=template&id=ab1b5f92&scoped=true&"
import script from "./FacilityOwnerCompanies.vue?vue&type=script&lang=js&"
export * from "./FacilityOwnerCompanies.vue?vue&type=script&lang=js&"
import style0 from "./FacilityOwnerCompanies.vue?vue&type=style&index=0&id=ab1b5f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1b5f92",
  null
  
)

export default component.exports